import * as yup from 'yup';
import { ObjectSchema } from 'yup';
import { UserErrorMessages, UserValidation } from '../../../../types';

export interface ObjectValidation extends Pick<UserValidation, 'required'> {}

// build validation schema for a object
export const buildObjectValidators = (
  { required }: ObjectValidation,
  errorMessages?: UserErrorMessages,
  hasBuiltIn?: boolean
) => {
  let schema: ObjectSchema<object | undefined | null, object> = yup.object();
  if (!hasBuiltIn) {
    // if we have builtIn validation for given component we don't want to set default value here. Use metadata file instead.
    schema = schema.default(undefined);
  }
  if (required) schema = schema.required(...required).nullable();
  return schema;
};
